import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from "typeorm";
import { SectionQuestionMappingEntity } from "./section-question-mapping.entity";
import { QuestionPaperModal } from "../../model-paper/entities/question-paper-modal";

@Entity("question_papers")
export class QuestionPapers {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "subject" })
  subject: number;

  @Column("text", { name: "qnos" })
  qnos: string;

  @Column("int", { name: "setno" })
  setNo: number;

  @Column("int", { name: "status" })
  status: number;

  @Column("varchar", { name: "created_at", length: 20 })
  createdAt: string;

  @Column("varchar", { name: "otp", length: 20, nullable: true })
  otp: string;

  @Column("varchar", { name: "paper_bundler_id", length: 20, nullable: false })
  paperBundlerId: string;

  @Column("text", { name: "qnos_order" })
  qnosOrder: string;

  @Column("int", { name: "created_by", nullable: true })
  createdBy: number;

  @Column("varchar", { name: "mode", length: 20, nullable: true })
  mode: string;

  @Column("decimal", { name: "easy_percentage", precision: 5, scale: 2, nullable: true, default: 0 })
  easyPercentage: number;

  @Column("decimal", { name: "moderate_percentage", precision: 5, scale: 2, nullable: true, default: 0 })
  moderatePercentage: number;

  @Column("decimal", { name: "hard_percentage", precision: 5, scale: 2, nullable: true, default: 0 })
  hardPercentage: number;

  @Column("decimal", { name: "awareness_percentage", precision: 5, scale: 2, nullable: true, default: 0 })
  awarenessPercentage: number;

  @Column("decimal", { name: "sensitivity_percentage", precision: 5, scale: 2, nullable: true, default: 0 })
  sensitivityPercentage: number;

  @Column("decimal", { name: "creativity_percentage", precision: 5, scale: 2, nullable: true, default: 0 })
  creativityPercentage: number;

  @ManyToOne(() => QuestionPaperModal, (qnpModel) => qnpModel.sectionsWiseModel)
  @JoinColumn({ name: 'qpcode' })
  qpCode: QuestionPaperModal

  @OneToMany(() => SectionQuestionMappingEntity, (sections) => sections.questionPaper, { cascade: true })
  sectionsQuestionMapping: SectionQuestionMappingEntity[];

}
